import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const horseshoeTaskRepository = RepositoryFactory.get('horseshoeTask')

class horseshoeTaskService {
  static async createHorseshoeTask (data) {
    try {
      return await horseshoeTaskRepository.createHorseshoeTask(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateHorseshoeTask (data) {
    try {
      return await horseshoeTaskRepository.updateHorseshoeTask(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }
}

export default horseshoeTaskService
